<div class="footer" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <span fxFlex="nogrow" fxFlex.xs="100" fxFlex.sm="100" fxLayout="row" fxLayoutAlign="center center"
        class="powered-by">
        <span>Powered by</span>
        &nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://optimiza.me/">
            <img class="optimiza-logo" src="./assets/logo optimiza w.svg" />
        </a>
    </span>
</div>